import axios from 'axios';

export const fetchSessionInfo = async () => {
  const response = await axios.get('/smart/session_info');
  return response.data;
};
